const RgAggregatorVersion = "25.0.3";
export {
  RgAggregatorVersion
};
//# sourceMappingURL=index81.js.map
